import React from "react";
import CommonContainer from "../Container/CommonContainer";
import { FaHeadset } from "react-icons/fa";

const MetlinkLeadSuppportComponent = () => {
  return (
    <CommonContainer icon={<FaHeadset size={20}/>} heading="Lead Support">
      <div className="mt-5">
        <div className="table-responsive">
          <table className="table table-bordered custom-table">
            <thead>
              <tr>
                {/* <th style={{ width: "20%" }}> Patient Name </th>
                <th style={{ width: "12%" }}> Patient Contact </th>
                <th style={{ width: "8%" }}> BU Name </th>
                <th style={{ width: "20%" }}> Last Test Consumed </th>
                <th style={{ width: "8%" }}> Test Name </th>
                <th style={{ width: "10%" }}> Last Visit Date </th> */}

                <th> Patient Name </th>
                <th> Patient Contact </th>
                <th> BU Name </th>
                <th> Last Test Consumed </th>
                <th> Test Name </th>
                <th> Last Visit Date </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "0.5rem" }}>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                ABC
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                8221789312
              </td>

              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                Pune
              </td>
              <td
                className="test-text-small"
                style={{ textAlign: "center", verticalAlign: "middle" }}
              >
                G00270R
              </td>

              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                Glucose Random
              </td>
              <td>27-Dec-24</td>
            </tbody>
          </table>
        </div>
      </div>
    </CommonContainer>
  );
};

export default MetlinkLeadSuppportComponent;
